import { render } from "./UangTipsView.vue?vue&type=template&id=91d79e6a&ts=true"
import script from "./UangTipsView.vue?vue&type=script&lang=ts"
export * from "./UangTipsView.vue?vue&type=script&lang=ts"

import exportComponent from "/home/admindb/web/crevent.pedasabis.com/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__